import { useEffect, useState } from 'react';
import type { MatchDevices } from '@aiscoreboard/contracts';
import { fetchMatchDevices } from './api';

export function useMatchDevices(matchId: string | null) {
  const [result, setResult] = useState<{
    matchId: string; data: MatchDevices | null; error: string | null;
  } | null>(null);
  useEffect(() => {
    if (!matchId) return;
    const controller = new AbortController();
    let timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      try {
        const data = await fetchMatchDevices(matchId, controller.signal);
        if (!controller.signal.aborted) setResult({ matchId, data, error: null });
      } catch (error) {
        if (!controller.signal.aborted) {
          setResult({ matchId, data: null, error: error instanceof Error ? error.message : String(error) });
        }
      } finally {
        if (!controller.signal.aborted) timer = setTimeout(() => void poll(), 5000);
      }
    };
    void poll();
    return () => { controller.abort(); clearTimeout(timer); };
  }, [matchId]);
  return result?.matchId === matchId ? result : null;
}
